import { useSnackbar } from 'notistack';
import { useState } from 'react';

import { useFilestack } from '@setvi/shared/hooks';

import { SearchFormProps } from '../..';

export const useImageInput = ({ onChange }: Partial<SearchFormProps>) => {
  const { enqueueSnackbar } = useSnackbar();
  const { fileStackUpload, filestackDelete } = useFilestack();

  const [loading, setLoading] = useState(false);
  const [focus, setFocus] = useState(false);
  const [handle, setHandle] = useState('');
  const [error, setError] = useState(false);

  const onDrop = async (acceptedFiles: File[]) => {
    setLoading(true);

    const file = acceptedFiles[0];
    if (!file) return;

    const res = await fileStackUpload({
      file,
      getProgress: () => {},
      error: {
        show: false
      }
    });

    setLoading(false);

    if (!res?.url) {
      enqueueSnackbar('File upload failed', {
        variant: 'error',
        autoHideDuration: 8000
      });
      setError(true);
      return;
    }

    onChange({ imageUrl: res?.url });
    setHandle(res?.handle);
    setError(false);
  };

  const onDropRejected = () => {
    setError(true);
    enqueueSnackbar('File type not supported', {
      variant: 'error',
      autoHideDuration: 8000
    });
  };

  const onRemoveImage = async () => {
    onChange({ imageUrl: '' });

    await filestackDelete(handle);
    setHandle('');
    setError(false);
  };

  return {
    focus,
    loading,
    error,
    onDrop,
    setFocus,
    onRemoveImage,
    onDropRejected
  };
};
